import { createSelector } from 'reselect'

import { TopicRootState } from '../topicRoot.reducer'

export const getAboTopics = createSelector(
  (state: TopicRootState) => state.topicStore.aboTopics,
  (state) => state,
)
export const getAboSettings = createSelector(
  (state: TopicRootState) => state.topicStore.aboSettings,
  (state) => state,
)
export const getUploadStatus = createSelector(
  (state: TopicRootState) => state.topicStore.uploadPending,
  (state) => state,
)
export const getTemporaryMediaFile = createSelector(
  (state: TopicRootState) => state.topicStore.temporaryFileMetadata,
  (state) => state,
)
export const getReNewSettingsStatus = createSelector(
  (state: TopicRootState) => state.topicStore.reNewSettings,
  (state) => state,
)
export const getAboHasPostings = createSelector(
  (state: TopicRootState) => state.topicStore.aboHasPostings,
  (state) => state,
)
export const getAuditLogForNetworkPage = createSelector(
  (state: TopicRootState) => state.topicStore.auditLogForCurrentUser,
  (state) => state,
)
